import { api, ApiRoutes } from '../services/ApiService'

export const useDeleteData = (url: ApiRoutes, id: number | string) => {
    const submit = async () => {
        return api.delete(url, id)
    }

    return {
        submit,
    }
}
